"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const constants_1 = require("../../constants/constants");
const screenWidth = react_native_1.Dimensions.get('window').width;
const styles = react_native_1.StyleSheet.create({
    cardDeleteBackground: {
        backgroundColor: theme_1.default.colors.COLOR_GRAY_LIGHT,
        paddingHorizontal: react_native_1.Platform.OS === 'web' ? 5 : 7.5,
        alignContent: 'center',
        alignItems: 'center',
    },
    Text: {
        flex: 1,
        fontFamily: constants_1.FONT_FAMILY,
        fontSize: 15,
        fontWeight: 'bold',
        letterSpacing: 0.25,
        color: theme_1.default.colors.COLOR_GRAY,
        textAlign: 'left',
    },
    accountNumberText: {
        flex: 1,
        fontFamily: constants_1.FONT_FAMILY,
        fontSize: 15,
        fontWeight: 'bold',
        letterSpacing: 0.25,
        color: theme_1.default.colors.COLOR_GRAY_DARK,
        textAlign: 'left',
    },
    primaryExtraText: {
        flex: 1,
        fontFamily: constants_1.FONT_FAMILY,
        fontSize: 11,
        letterSpacing: 0.25,
        color: theme_1.default.colors.COLOR_BLACK,
        textAlign: 'left',
        paddingTop: 10,
    },
    extraText: {
        flex: 1,
        fontFamily: constants_1.FONT_FAMILY,
        fontSize: 11,
        letterSpacing: 0.25,
        color: theme_1.default.colors.COLOR_BLACK,
        textAlign: 'left',
        paddingTop: 10,
    },
    imageContainer: {
        flex: react_native_1.Platform.OS === 'web' && screenWidth > constants_1.BREAK_POINT_WIDTH ? 0.9 : 1.4,
        paddingTop: react_native_1.Platform.OS === 'web' && screenWidth > constants_1.BREAK_POINT_WIDTH ? '4%' : '9%',
        paddingLeft: 5,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'flex-start',
    },
    deleteCardContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        padding: 10,
    },
    messageContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: 20,
        paddingRight: 30,
    },
    messageContainerSpacing: {
        flex: 1,
        alignContent: 'flex-start',
        justifyContent: 'space-between',
        paddingLeft: react_native_1.Platform.OS === 'web' ? 15 : 5,
    },
});
exports.default = styles;
